<template>
  <a-modal :title="title" :width="width" :visible="visible" switchFullscreen @cancel="handleCancel" :cancelText="$t('关闭')">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('姓名')">
              <a-input :placeholder="$t('输入姓名查询')" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" @click="addFamily" icon="plus">{{ $t('新建家庭成员') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length>0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <a-table rowKey="id" :loading="loading" :dataSource="dataSource" :columns="columns" :pagination="ipagination" :rowSelection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange}">
      <template slot="sex" slot-scope="sex">
        <span>{{sex == 1?$t('男'):sex == 2?$t('女'):''}}</span>
      </template>
      <template slot="marriageState" slot-scope="marriageState">
        <span>{{marriageState == 1?$t('已婚'):marriageState == 2?$t('未婚'):''}}</span>
      </template>
      <span slot="action" slot-scope="text, record" class="action">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
        <a-dropdown>
          <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              <a @click="handleDelete(record)">{{ $t('删除') }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <template slot="footer">
      <a-button @click="handleCancel">{{ $t('关闭') }}</a-button>
    </template>
    <family-members-modal ref="formModalRef" @refresh="getList()"></family-members-modal>
  </a-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import FamilyMembersModal from './FamilyMembersModal';
  import {
    getAction,
    deleteAction
  } from '@/api/manage'
  import { listSize } from '@/utils/util'
  export default {
    name: 'FamilyMembersTableModal',
    mixins:[JeecgListMixin],
    components: {
      FamilyMembersModal
    },
    data() {
      return {
        title: this.$t('家庭成员'),
        visible: false,
        width: 1500,
        disableSubmit: false,
        familyId: '',
        currentRow: {},
        selectedRowKeys: [],
        url: {
          add: '/jeecg-charge/meter/meterUserFamilyMembers/add',
          idDelete: '/jeecg-charge/meter/meterUserFamilyMembers/delete',
          deleteBatch: '/jeecg-charge/meter/meterUserFamilyMembers/deleteBatch',
          edit: '/jeecg-charge/meter/meterUserFamilyMembers/edit',
          list: '/jeecg-charge/meter/meterUserFamilyMembers/list',
          queryById: '/jeecg-charge/meter/meterUserFamilyMembers/queryById',
        },
        dataSource: [],
      }
    },
    computed: {
      // i18n：表格列使用 computed 以响应语言切换
      columns() {
        return [{
            title: this.$t('姓名'),
            dataIndex: 'name',
            key: 'name'
          },
          {
            title: this.$t('职业'),
            dataIndex: 'occupation',
            key: 'occupation'
          },
          {
            title: this.$t('籍贯'),
            dataIndex: 'origin',
            key: 'origin'
          },
          {
            title: this.$t('性别'),
            dataIndex: 'sex',
            key: 'sex',
            scopedSlots: {
              customRender: 'sex'
            }
          },
          {
            title: this.$t('身份证号'),
            dataIndex: 'identificationNumber',
            key: 'identificationNumber'
          },
          {
            title: this.$t('婚姻状况'),
            dataIndex: 'marriageState',
            key: 'marriageState',
            scopedSlots: {
              customRender: 'marriageState'
            }
          },
          {
            title: this.$t('学历'),
            dataIndex: 'degree',
            key: 'degree'
          },
          {
            title: this.$t('手机号'),
            dataIndex: 'phoneNumber',
            key: 'phoneNumber'
          },
          {
            title: this.$t('工作单位'),
            dataIndex: 'workplace',
            key: 'workplace'
          },{
            title: this.$t('操作'),
            dataIndex:'action',
            align:"center",
            fixed:"right",
            width:190,
            scopedSlots: { customRender: 'action'}
          }
        ]
      },
    },
    methods: {
      // 初始化
      init(row) {
        this.visible = true;
        this.currentRow = row;
        this.getList();
        
      },
      handleCancel() {
        this.visible = false;
      },
      // 新建家庭成员
      addFamily() {
        this.$nextTick(() => {
          this.$refs.formModalRef.init(this.currentRow,null,'add');
        });
      },
      // 列表
      getList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.userId =  this.currentRow.userId;
        getAction(this.url.list,params).then(res => {
          this.dataSource = res.result.records;
        })
      },
      handleEdit(row){
        this.$nextTick(() => {
          this.$refs.formModalRef.init(this.currentRow,row,'edit');
        });
      },
      handleDetail(row){
        this.$nextTick(() => {
          this.$refs.formModalRef.init(this.currentRow,row,'detail');
        });
      },
      handleDelete(row){
        let that = this;
        that.$confirm({
          title: that.$t('确定删除吗?'),
          content: that.$t('将会删除当前家庭成员信息,请慎重操作!'),
          onOk() {
            let params = {
              id: row.id
            }
            deleteAction(that.url.idDelete, params).then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
              } else {
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      onSelectChange(index,e){
        this.selectedRowKeys = [];
        e.forEach(item=>{
          this.selectedRowKeys.push(item.id);
        });
      },
      batchDel(){
        var ids = "";
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
        var that = this;
        this.$confirm({
          title: this.$t('确认删除'),
          content: this.$t('是否删除选中数据?'),
          onOk: function () {
            that.loading = true;
            deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.selectedRowKeys = [];
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.loading = false;
            });
          }
        });
      }
    }
  }
</script>

<style>
</style>
